import { render, staticRenderFns } from "./RegionListToSelect.vue?vue&type=template&id=4e045d72"
import script from "./RegionListToSelect.vue?vue&type=script&lang=js"
export * from "./RegionListToSelect.vue?vue&type=script&lang=js"
import style0 from "./RegionListToSelect.vue?vue&type=style&index=0&id=4e045d72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports